const replaceAll = (str, find, replace) => str.replace(new RegExp(find, "g"), replace);
const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const toCamelCase = (str) => str.replace(/[-_\s]\w/g, (match) => match.charAt(1).toUpperCase());
const toKebabCase = (str) => str.replace(/([a-z\d])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
const toParagraph = (str) => str.split(/(?=[A-Z])|_| |-/).filter((word) => word.trim() !== "").join(" ").toLowerCase();
const kebabCaseToText = (str) => {
  const string = str.replace(/_/g, " ");
  return string;
};
const toId = (str) => toKebabCase(str.replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa")).replace(/[^a-zA-Z\d\s-]/g, "-").replace(/-{2,}/g, "-").replace(/^-+|-+$/g, "");
const getFileExtension = (filename) => {
  const regex = /\.[0-9a-zA-Z]+$/;
  const match = filename.match(regex);
  return match ? match[0] : null;
};
const removeFileExtension = (filename) => {
  const regex = /\.[0-9a-zA-Z]+$/;
  return filename.replace(regex, "");
};
const isNumber = (char) => /^\d$/.test(char);
const truncateMiddle = (str, containerWidth) => {
  const maxLength = containerWidth / 8;
  if (str.length <= maxLength) {
    return str;
  }
  const ellipsis = "...";
  const prefixLength = Math.floor((maxLength - ellipsis.length) / 2);
  const suffixLength = Math.ceil((maxLength - ellipsis.length) / 2);
  const prefix = str.substring(0, prefixLength);
  const suffix = str.substring(str.length - suffixLength);
  return prefix + ellipsis + suffix;
};
const clampVal = (value) => Math.max(0, value);
const deepMerge = (a, b) => {
  const merged = { ...a };
  Object.keys(b).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(b, key)) {
      if (b[key] instanceof Object && Object.prototype.hasOwnProperty.call(a, key) && a[key] instanceof Object) {
        merged[key] = deepMerge(a[key], b[key]);
      } else {
        merged[key] = b[key];
      }
    }
  });
  return merged;
};
const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    return `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
      result[3],
      16
    )})`;
  }
  return "error";
};
const log = ({
  type,
  message,
  env,
  tracker
}) => {
  var _a;
  let resolvedEnv = "prod";
  if (env) {
    resolvedEnv = env;
  } else if (typeof window !== "undefined") {
    if (window.location.href.includes(".ci.") || window.location.href.includes(".tst.")) {
      resolvedEnv = "ci";
    }
    if (window.location.href.includes(".uat.") || window.location.href.includes(".prep.")) {
      resolvedEnv = "uat";
    }
    if (window.location.href.includes("localhost") || window.location.href.includes(".dev.")) {
      resolvedEnv = "dev";
    }
  }
  if (resolvedEnv !== "prod") {
    if (type === "error") {
      console.error(message);
    } else if (type === "warning") {
      console.warn(message);
    } else {
      console.log(message);
    }
  }
  if (tracker && resolvedEnv === "prod") {
    (_a = tracker == null ? void 0 : tracker.monitor) == null ? void 0 : _a.exception({
      message,
      severityLevel: 3
    });
  }
};
export {
  capitalize,
  clampVal,
  deepMerge,
  getFileExtension,
  hexToRgb,
  isNumber,
  kebabCaseToText,
  log,
  removeFileExtension,
  replaceAll,
  toCamelCase,
  toId,
  toKebabCase,
  toParagraph,
  truncateMiddle
};
